























































































import {
  Component, Watch, mixins, Inject,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { formatDate } from '@/utils/date-utils';
import { toMoney } from '@/utils/common-utils';

class PlayersContentState {
  public list: Array<object> = []

  public totalPageSize: number = 0

  public pageNo: number = 1

  public pageSize: number = 100

  public loading: boolean = false

  public prevScrollTop: number = 0
}

@Component({
  /**
   * Imported components
   * */
  components: {},
  /**
   * Stores values
   * */
  computed: {},
  /**
   * Component properties
   * */
  props: {
    data: {
      type: Object,
      required: true,
    },
    displayColumns: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  directives: {
    tableLoad: {
      // directive definition
      componentUpdated(el) {

      },
    },
  },
})
export default class PlayersContent extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new PlayersContentState();

  @Inject() readonly DATE_COLUMN!: string

  @Inject() readonly USERNAME_COLUMN!: string

  @Inject() readonly LEVEL_COLUMN!: string

  @Inject() readonly PLAYER_ID_COLUMN!: string

  @Inject() readonly SIGNUP_COLUMN!: string

  @Inject() readonly FTD_COLUMN!: string

  @Inject() readonly NGR_COLUMN!: string

  @Inject() readonly DEPOSITS_COLUMN!: string

  @Inject() readonly WITHDRAWALS_COLUMN!: string

  @Inject() readonly COMMISSION_COLUMN!: string

  @Inject() readonly TIER_COMMISSION_COLUMN!: string

  /**
   * Watchers
   * */
  @Watch('$props.data', { immediate: true })
  dataWatcher(data: Array<object>) {
    const size = this.getObject(data, 'player_sales', []).length / this.state.pageSize;
    this.state.totalPageSize = Number.parseInt(size.toString());
    this.state.pageNo = 1;
    console.log(this.state.totalPageSize, this.state.pageNo);
    this.state.list = this.getListData;
  }

  /**
   * Methods
   * */
  loadMore() {
    console.log('fetching ... ');
    this.state.loading = true;
    const e = this.mainContainerElement;
    this.state.prevScrollTop = e.scrollTop;

    setTimeout(() => {
      this.state.pageNo += 1;
      this.state.loading = false;
      this.state.list = [...this.state.list, ...this.getListData];
    }, 500);
  }

  /**
   * Computed
   * */
  get getListData() {
    const page = this.state.pageNo;
    const perPage = this.state.pageSize;
    const from = (page * perPage) - perPage;
    const to = (page * perPage);
    const clone = [...this.getObject(this.$props.data, 'player_sales', [])];
    return clone.slice(from, to);
  }

  get noMore() {
    return this.state.list.length === this.getObject(this.$props.data, 'player_sales', []).length;
  }

  get disabled() {
    return this.state.loading || this.noMore;
  }

  get mainContainerElement() {
    return document.querySelector('#content-container');
  }

  /**
   * Lifecycle hooks
   * */
  mounted() {
    const listElm = this.mainContainerElement;
    listElm.addEventListener('scroll', (e) => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight && !this.disabled) {
        this.loadMore();
      }
    });
  }

  beforeDestroy() {
    const listElm = this.mainContainerElement;
    listElm.removeEventListener('scroll', (e) => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight && !this.disabled) {
        this.loadMore();
      }
    });
  }

  beforeCreate() {
    this.dateUtils = {
      formatDate,
    };

    this.commonUtil = {
      toMoney,
    };
  }
}
